class KlaviyoTracking {
  constructor() {
    if (!klaviyo) return
    this.setListener();
  }

  setListener() {
     subscribe(
      PUB_SUB_EVENTS.wishlistChange,
      () => this.onWishlistEvent()
    );

     subscribe(PUB_SUB_EVENTS.onGenericTrackEvent, (event) => {
      this.pushEvents(event.events);
    });
  }

  onWishlistEvent() {
    const wishlist = WishlistUtils.wishlist;
    const payload = {
      'Products': wishlist.map((item) => item.id)
    }

    this.trackEvent('Update_Wishlist', payload);
  }

  trackEvent(event, payload) {
    try {
      const customerEmail = window.customer?.email;
      if (!customerEmail) return;

      klaviyo.identify({'$email' :  customerEmail })
          .then(() => {
            klaviyo.track(event, payload);
          })
    } catch (error) {
      console.error('Error sending Klaviyo event:', error);
    }
  }

  pushEvents(events) {
    try {
      const customerEmail = window.customer?.email;

      if (!customerEmail) return;

      klaviyo.identify({'$email' :  customerEmail })
          .then(() => {
            events.forEach(event => {
              klaviyo.push(event);
            });
          })
    } catch (error) {
      console.error('Error sending Klaviyo event:', error);
    }
    
  }


}
new KlaviyoTracking();